import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '@famly/mf_data-display_icon';
import { Stack } from '@famly/mf_layout_stack';
import { Box } from '@famly/mf_layout_box';
import { history } from 'signin-app/redux/store';
const HeaderBackButton = () => {
    const handleOnClick = React.useCallback(() => {
        history.goBack();
    }, []);
    return (_jsx(Stack, { borderRadius: "50%", width: "48px", height: "48px", alignItems: "center", justifyContent: "center", borderWidth: "1px", borderStyle: "solid", borderColor: "n200", onClick: handleOnClick, flexShrink: 0, cursor: "pointer", children: _jsx(Icon, { name: "arrow_back", color: "n400" }) }));
};
const Header = ({ rightElement, centerElement }) => {
    return (_jsxs(Stack, { justifyContent: "space-between", alignItems: "center", gap: 3, children: [_jsx(HeaderBackButton, {}), centerElement, _jsx(Box, { children: rightElement })] }));
};
export default Header;
